import { render, staticRenderFns } from "./CardPage.vue?vue&type=template&id=41ba93b0&scoped=true"
import script from "./CardPage.vue?vue&type=script&lang=js"
export * from "./CardPage.vue?vue&type=script&lang=js"
import style0 from "./CardPage.vue?vue&type=style&index=0&id=41ba93b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ba93b0",
  null
  
)

export default component.exports